const ventures = {
  monopolycasino: {
    key: 'monopolycasino',
    name: 'monopolycasino',
    urls: {
      staging: 'https://www.monopolycasino.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.monopolycasino.com'
    },
    sitemapPath: '/',
    country: 'uk',
    tealiumTag: 'monopolycasino',
    pixelSupport: false,
    bingoCommetDId: 21,
    launchDate: null
  },
  jackpotjoy: {
    key: 'jackpotjoy',
    name: 'jackpotjoy',
    urls: {
      staging: 'https://jackpotjoy.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.jackpotjoy.com'
    },
    sitemapPath: '/uk/',
    country: 'uk',
    tealiumTag: 'jackpotjoy',
    pixelSupport: false,
    bingoCommetDId: 2,
    launchDate: null
  },
  virgingames: {
    key: 'virgingames',
    name: 'virgingames',
    urls: {
      staging: 'https://www.virgingames.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.virgingames.com'
    },
    sitemapPath: '/uk/',
    country: 'uk',
    tealiumTag: 'virgingames',
    pixelSupport: false,
    bingoCommetDId: 14,
    launchDate: null
  },
  rainbowrichescasino: {
    key: 'rainbowrichescasino',
    name: 'rainbowrichescasino',
    urls: {
      staging: 'https://www.rainbowrichescasino.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.rainbowrichescasino.com'
    },
    sitemapPath: '/uk/',
    country: 'uk',
    tealiumTag: 'rainbowrichescasino',
    pixelSupport: false,
    bingoCommetDId: 25,
    launchDate: null
  },
  botemania_es: {
    key: 'botemania_es',
    name: 'botemania_es',
    urls: {
      staging: 'https://www.botemania.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.botemania.es'
    },
    sitemapPath: '/es/',
    country: 'es',
    tealiumTag: 'botemania',
    pixelSupport: false,
    bingoCommetDId: 3,
    launchDate: null
  },
  monopolycasino_es: {
    key: 'monopolycasino_es',
    name: 'monopolycasino_es',
    urls: {
      staging: 'https://es.monopolycasino.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.monopolycasino.es'
    },
    sitemapPath: '/es/',
    country: 'es',
    tealiumTag: 'monopolycasinospain',
    pixelSupport: false,
    bingoCommetDId: 26,
    launchDate: null
  },
  doublebubblebingo: {
    key: 'doublebubblebingo',
    name: 'doublebubblebingo',
    urls: {
      staging: 'https://doublebubblebingo.ppc1.pgt01.gamesysgames.com',
      url: 'https://www.doublebubblebingo.com'
    },
    sitemapPath: '/uk/',
    country: 'uk',
    tealiumTag: 'doublebubblebingo',
    pixelSupport: false,
    bingoCommetDId: 5,
    launchDate: null
  },
  virgincasino: {
    key: 'virgincasino',
    name: 'virgincasino',
    urls: {
      staging: 'https://www.virgincasino.stg.pp21.pgt.gamesysgames.com',
      url: 'https://www.virgincasino.com'
    },
    sitemapPath: '/nj/',
    country: 'nj',
    tealiumTag: 'virgincasino',
    pixelSupport: false,
    bingoCommetDId: null,
    launchDate: null
  },
  ballycasinonj: {
    key: 'ballycasinonj',
    name: 'ballycasinonj',
    urls: {
      staging: 'https://www.ballycasino.stg.eu00.aws.ballys.tech/',
      url: 'https://www.ballycasino.com'
    },
    sitemapPath: '/',
    country: 'nj',
    tealiumTag: 'ballycasinonj',
    pixelSupport: true,
    bingoCommetDId: null,
    launchDate: '06 Dec 2021 10:00:00 GMT+0000',
    gpcFeatureEnabled: true
  },
  ballybetaz: {
    key: 'ballybetaz',
    name: 'ballybetaz',
    urls: {
      staging: 'https://www.ballybet.stg.pp21.pgt.gamesysgames.com',
      url: 'https://www.ballybet.com'
    },
    sitemapPath: '/',
    country: 'na',
    tealiumTag: 'ballybet',
    pixelSupport: true,
    bingoCommetDId: null,
    launchDate: null,
    gpcFeatureEnabled: true
  },
  ballybetca: {
    key: 'ballybetca',
    name: 'ballybetca',
    urls: {
      staging: 'https://www-ca.ballybet.stg.pp21.pgt.gamesysgames.com',
      url: 'https://www.ballybet.ca'
    },
    sitemapPath: '/',
    country: 'ca',
    tealiumTag: 'ballybetcanada',
    pixelSupport: true,
    bingoCommetDId: null,
    launchDate: null
  },
  ballyuk: {
    key: 'ballyuk',
    name: 'ballyuk',
    urls: {
      staging: 'https://uk.ballycasino.npe00.pgt.ballys.tech/',
      url: 'https://www.ballycasino.co.uk'
    },
    sitemapPath: '/online-games/',
    country: 'uk',
    tealiumTag: 'ballyuk',
    pixelSupport: false,
    bingoCommetDId: 12,
    launchDate: null
  },
  ballycasinogr: {
    key: 'ballycasinogr',
    name: 'ballycasinogr',
    urls: {
      staging: 'https://www.ballycasinogr.npe00.pgt.ballys.tech',
      url: 'https://www.ballybet.gr/'
    },
    sitemapPath: '/online-games/',
    country: 'uk',
    tealiumTag: 'ballycasinogr',
    pixelSupport: false,
    bingoCommetDId: 12,
    launchDate: null
  },
  monopolycasinous: {
    key: 'monopolycasinous',
    name: 'monopolycasinous',
    urls: {
      staging: 'https://www.monopolycasinous.stg.pp21.pgt.gamesysgames.com',
      url: 'https://www.monopolycasinous.com'
    },
    sitemapPath: '/',
    country: 'na',
    tealiumTag: 'monopolycasinous',
    pixelSupport: false,
    bingoCommetDId: null,
    launchDate: null
  },
  monopolycasinoca: {
    key: 'monopolycasinoca',
    name: 'monopolycasinoca',
    urls: {
      staging: 'https://www.monopolycasinoon.stg.eu00.aws.ballys.tech/',
      url: 'https://www.monopolycasino.ca'
    },
    sitemapPath: '/',
    country: 'ca',
    tealiumTag: 'monopolycasinocanada',
    pixelSupport: false,
    bingoCommetDId: null,
    launchDate: null
  }
}

module.exports = ventures
